/* @flow */

import { rem } from 'polished';

import { listReset } from 'src/shared/app/base/style/token/helper';
import { mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: listReset,

    display: 'flex',
  },
  item: {
    '&:not(:last-child):after': {
      content: "'|'",

      margin: [0, rem(8, baseFontSize)],

      opacity: 0.5,
      color: mediumGrey,
    },
  },
};
